import { Link } from "gatsby";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { LANGUAGE } from "../../../../../company/settings/translations";
import { getSlugWithLang } from "../../Shared/Utils/getSlugWithLang";
import Toolbar from "./hamburger/Toolbar";
import { logo_svg } from "./header-elements";
import Navbar from "./navbar/Navbar";
import NavbarLinks from "./navbarLinks/NavbarLinks";
import Sidebar from "./sidebar/Sidebar";
import { useSidebar } from "./sidebar/useSidebar";

export const Header = (): JSX.Element => {
  const [sidebar, toggle] = useSidebar();
  const mHeader = useRef() as React.MutableRefObject<HTMLDivElement>;
  const { i18n } = useTranslation("global");

  function setHeight() {
    if (!mHeader.current) return;
    const { height } = mHeader.current.getBoundingClientRect();
    document.documentElement.style.setProperty(
      "--vh-size",
      `${window.innerHeight * 0.01}px`,
    );
    document.documentElement.style.setProperty(
      "--header-height",
      `${height}px`,
    );
  }
  function onResize() {
    setHeight();
  }

  useEffect(() => {
    setHeight();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header ref={mHeader} className={"m-header"}>
      <div
        className={`header__overlay ${
          sidebar ? "header__overlay--sidebar" : ""
        }`}
        onClick={toggle}
      />
      <div className="c-header">
        <Link
          to={getSlugWithLang("/", i18n.language as LANGUAGE)}
          className={"header__c-logo"}
        >
          {logo_svg}
        </Link>
        <NavbarLinks desktop />
        <Toolbar sidebar={sidebar} toggle={toggle} />
      </div>
      <Sidebar sidebar={sidebar} toggle={toggle} />
    </header>
  );
};

export default Header;
